export default __webpack_public_path__ + "locales/uk-UA/Payments.json?hash=203e20479d3980d293ccc5a80e713894";